import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiAction, generalSet } from '../../store/generalSlice';

const CreateGeneralSettings = () => {
  const dispatch = useDispatch();
  const { newGeneralSettings, loadingNewGeneralSettings } = useSelector((state) => state.general);

  const [generalSettingData, setGeneralSettingData] = useState({
    name: '',
    spendDisPercentage: 0,
    ruleFrequency: 0,
  });

  if (newGeneralSettings?._id) {
    window.location.href = '/generalSettings';
  }

  return (
    <div className='border p-2' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center pt-lg-0 border-bottom'>
        <h5>Create New Gemeral Settings</h5>
      </div>
      <div className='row d-flex justify-content-center pt-lg-0 p-4'>
        <div className='col-lg-8 mt-4 pt-lg-0'>
          <label>General Setting Name</label>
          <input
            type='text'
            className='form-control'
            placeholder='General Setting Name'
            style={{ textAlign: 'center' }}
            value={generalSettingData.name}
            onChange={(e) => setGeneralSettingData({ ...generalSettingData, name: e.target.value })}
          />
        </div>
        <div className='col-lg-6 mt-4 pt-lg-0'>
          <label>Spend Disrepancy Percentage</label>
          <input
            type='number'
            className='form-control'
            placeholder='Spend Dis Percentage'
            style={{ textAlign: 'center' }}
            value={generalSettingData.spendDisPercentage}
            onChange={(e) => setGeneralSettingData({ ...generalSettingData, spendDisPercentage: e.target.value })}
          />
        </div>
        <div className='col-lg-6 mt-4 pt-lg-0'>
          <label>Rule Frequency</label>
          <input
            type='number'
            className='form-control'
            placeholder='Rule Frequency'
            style={{ textAlign: 'center' }}
            value={generalSettingData.ruleFrequency}
            onChange={(e) => setGeneralSettingData({ ...generalSettingData, ruleFrequency: e.target.value })}
          />
        </div>
        {generalSettingData.name && generalSettingData.spendDisPercentage && generalSettingData.ruleFrequency ? (
          <div className='col-lg-12 d-flex justify-content-center mt-4 pt-lg-0' data-aos='fade-up' data-aos-delay='200'>
            <button
              className='btn btn-primary'
              disabled={loadingNewGeneralSettings}
              onClick={() => {
                dispatch(generalSet({ reduxField: 'loadingNewGeneralSettings', value: true }));
                dispatch(
                  apiAction({
                    route: 'generalSettings/createGeneralSetting',
                    reduxField: 'newGeneralSettings',
                    generalSettingData,
                    setLoading: 'loadingNewGeneralSettings',
                  })
                );
              }}
            >
              {loadingNewGeneralSettings ? 'Creating...' : 'Create General Settings'}
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CreateGeneralSettings;
